
import * as angular from "angular";

import { CompanyImageController } from "./companyImage.controller";

angular
    .module("app.components.companyImage", ["ngMaterial", "ngMessages"])
    .controller("companyImageController", CompanyImageController);
